module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-select', {
    attrs: {
      "items": _vm.list,
      "label": "Tipo de Propiedad",
      "item-text": "description",
      "item-value": "id"
    },
    model: {
      value: (_vm.app_tipo_propiedad_id),
      callback: function($$v) {
        _vm.app_tipo_propiedad_id = $$v
      },
      expression: "app_tipo_propiedad_id"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e93b0cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppTipoPropiedad.vue
// module id = 84
// module chunks = 1